import { EmailTemplateDetail } from '@dealstack/frontend/shared/components/EmailTemplates/components/EmailTemplateDetail';
import { EmailTemplateList } from '@dealstack/frontend/shared/components/EmailTemplates/components/EmailTemplateList';
import { StyledEmailTemplatesContainer } from '@dealstack/frontend/shared/components/EmailTemplates/styles';
import { EmailTemplateScopeKind } from '@dealstack/frontend/shared/components/EmailTemplates/EmailTemplates.types';
import { useMemo } from 'react';

interface Props {
	organizationId: string;
	templateType?: string;
	onSelectTemplate: (templateType: string | null) => void;
}

export const ProgrammeDefaultsEmailTemplates = ({
	organizationId,
	templateType,
	onSelectTemplate,
}: Props) => {
	const scope = useMemo(
		() => ({ kind: EmailTemplateScopeKind.ORGANIZATION, id: organizationId }),
		[organizationId]
	);

	return (
		<StyledEmailTemplatesContainer>
			{templateType ? (
				<EmailTemplateDetail
					scope={scope}
					templateType={templateType}
					onBack={() => onSelectTemplate(null)}
				/>
			) : (
				<EmailTemplateList scope={scope} onEdit={onSelectTemplate} />
			)}
		</StyledEmailTemplatesContainer>
	);
};
